export default {
      id: "group-usage",
      viewBox: "0 0 26 33",
      url: __webpack_public_path__ + "sprite.svg#group",
      toString: function () {
        return this.url;
      }
    }